import React from 'react';

import { observer } from 'mobx-react';

import classes from './CurrentPlanWidget.module.scss';
import { BillingPeriodType } from '../../../../../../payment/constants/billingPeriodType';
import { InfoBox } from '../../../../../../shared/components/ui-components';
import { SubmitButton } from '../../../components/SubmitButton/SubmitButton';
import { getCurrentUrl, goTo } from '../../../../../../shared/utils/angularUtils';
import { BillingPeriodTypeChip, pathQueryParams } from '../../../../../../payment';
import { SCAN_IQ_PAYMENT_RESULT_TYPE } from '../../../../../../payment/constants/scanIqPaymentResultType';
import { entitySignUpStore } from '../../../../../../shared/stores/entity/entitySignUpStore';

type CurrentPlanWidgetProps = {
  subscriptionName: string;
  billingPeriodType: BillingPeriodType;
};

const CurrentPlanWidget = observer(
  ({ subscriptionName, billingPeriodType }: CurrentPlanWidgetProps) => {
    const { entityId } = entitySignUpStore;

    const onSubmit = () => {
      const currentUrl = getCurrentUrl();
      goTo('/scaniq-payment-result', {
        params: {
          [pathQueryParams.entityId]: entityId,
          [pathQueryParams.redirectStatus]: 'succeeded',
          [pathQueryParams.retryPath]: currentUrl,
          [pathQueryParams.paymentResultType]:
            SCAN_IQ_PAYMENT_RESULT_TYPE.ALREADY_SUBSCRIBED,
        },
      });
    };

    return (
      <>
        <InfoBox title="Current Plan" customMargin>
          <p className={classes.title}>{subscriptionName}</p>
          <BillingPeriodTypeChip billingPeriodType={billingPeriodType} />
        </InfoBox>
        <SubmitButton onSubmit={onSubmit} />
      </>
    );
  },
);

export { CurrentPlanWidget };
